/** Animation Delay. */
export const ANIMATION_DELAY = {
  EXTRA_FAST: 200,
  VERY_FAST: 400,
  FAST: 1000,
  MEDIUM: 3000,
  SLOW: 5000,
  VERY_SLOW: 8000,
} as const;

/** Animation Duration. */
export const ANIMATION_DURATION = {
  VERY_FAST: 50,
  FAST: 100,
  MEDIUM: 300,
  SLOW: 1000,
  VERY_SLOW: 3000,
} as const;
